import { GeofencesService } from "../services/geofences-service";
import { EcaSecaModelBase } from "./eca-seca-zones-model";
import { ZoneFeature } from "./zones-base-interfaces";
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

export class EcaSecaModelImpl extends EcaSecaModelBase {
  async getEcaSecaZones(): Promise<ZoneFeature[] | null> {
    if (!this._zones) {
      await this.fetchZones();
    }
    return this._zones;
  }

  constructor(geojson?: ZoneFeature[]) {
    super();

    //for testing purposes, we can pass a geojson object
    if (geojson) {
      this._zones = geojson;
    } else {
      setInterval(() => this.fetchZones(), 60 * 60 * 1000); // refresh the list every 1h
    }
  }

  private _zones: ZoneFeature[] | null = null;

  private async fetchZones() {
    try {
      if (isVesselOnCloud && !isOnline()) {
        const cached = await IndexedDBService.zones.getByType('ECA');
        if (cached) {
          this._zones = cached;
        }
        return;
      }
      const zones: ZoneFeature[] = await GeofencesService.fetchGeofenceByZone("ECA");
      if (zones) {
        this._zones = zones;
        await IndexedDBService.zones.save('ECA', zones);
      }
    } catch (error) {
      console.warn('Failed to fetch ECA zones from API, falling back to IndexedDB', error);
      const cached = await IndexedDBService.zones.getByType('ECA');
      if (cached) {
        this._zones = cached;
      }
    }
  }
}
